module.exports = __webpack_public_path__ + "img/slide-1.44e17ab.webp";